export const AuthErrors = {
  NOT_AUTHENTICATED: 'not_authenticated',
  TWO_FACTOR_NOT_VERIFIED: '2fa_not_verified',
};
